import {
  get, includes, isEmpty, identity,
} from 'lodash/fp';
import Cookies from 'js-cookie';
import qs from 'query-string';

import { CLASSTING_AUTH_URL, CLASSTING_CLIENT_ID } from '../../../constants';
import { http, isWebView } from '../../../utils';
import * as logServices from '../../log/services';

const setupInterceptors = (store) => {
  http.interceptors.request.use((config) => {
    if (isEmpty(get('Authorization', config.headers))) {
      const accessToken = Cookies.get('access_token');

      Object.assign(config.headers, {
        ...config.headers,
        Authorization: `Bearer ${accessToken}`,
      });
    }

    return config;
  });

  http.interceptors.response.use((response) => {
    const state = store.getState();
    // XXX: 최초 접속 시 유저 정보가 스토어에 저장되기 전에 호출되는 경우가 존재. 이 경우에 유저 정보가 저장되어있지 않음.
    const params = {
      id: state.user.info.user_id || '',
      role: state.user.info.role || '',
      grade: 0,
      app_version: navigator.appVersion,
      country: state.user.info.country_code || navigator.language,
      language: state.user.info.language || navigator.language,
      method: response.config.method,
      api: response.config.url,
      code: response.status,
      device: 'web.event',
      client_time: new Date().getTime(),
      msg: (response.data || {}).error_description,
    };

    logServices.sendApiLog(response, params);
    return response;
  });

  http.interceptors.response.use(identity, (error) => {
    if (includes(get('status', error.response), [401])) {
      if (!isWebView()) {
        const authParams = qs.stringify({
          client_id: CLASSTING_CLIENT_ID,
          response_type: 'id_token token',
          scope: 'openid email profile',
          nonce: Math.random().toString(36).substring(10),
          redirect_uri: `${window.location.origin}/users/callback`,
        });

        window.location.replace(`${CLASSTING_AUTH_URL}/auth?${authParams}`);
      }
    }

    return Promise.reject(error);
  });
};

export default setupInterceptors;
